module.exports = __webpack_public_path__ + "img/register-image.196377eb.png";